<template>
  <div class="vx-col w-full">
    <vx-card title no-shadow card-border>
      <div>
        <div class="w-full mb-2">
          <div class="version-container">
            <div class="tag">
              {{ mode === "edit" ? "DRAFT" : planStatus }}
            </div>
            <div class="tag" v-if="planVersion > 0">
              {{$t("setup.label.Version")}} :
              {{
                planStatus === "ACTIVE" && mode === "edit"
                  ? planVersion + 1
                  : planVersion
              }}
            </div>
            <div
              class="tag-approval"
              v-if="planStatus === 'DRAFT' && mode != 'view'"
              @click="makerCheckerApproval()"
            >
              {{ $t("setup.label.requestApproval") }}
            </div>
          </div>
        </div>
        <div class="vx-row less-padding" v-show="mode != 'view'">
          <div class="vx-col w-3/5 less-padding">
            <div class="vx-row border-left heading">
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.PlanCode") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.ProductCode") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.ChargeCode") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.ChargeOwner") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.Resource") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.RoundingType") }}
              </div>
            </div>
          </div>
          <div class="vx-col w-2/5 less-padding">
            <div class="vx-row border-left heading" style="height: 100%">
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                {{ $t("setup.label.Duration") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                {{ $t("setup.label.GLID") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                {{ $t("setup.label.ListPrice") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                {{ $t("setup.label.SellingPrice") }}
                <!-- New heading -->
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                {{ $t("setup.label.Actions") }}
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row less-padding" v-show="mode != 'view'">
          <div class="vx-col w-3/5 less-padding">
            <div class="vx-row border-left py-2" style="height: 100%">
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <vs-input
                  class="w-full mb-2 font-semibold padding-zero"
                  :placeholder="$t('setup.label.EnterPlanDescription')"
                  v-model="priceWithTemplate.planCode"
                  readonly
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <v-select
                  label="productDescription"
                  v-model="productCode"
                  :clearable="false"
                  :options="priceWithTemplate.serviceData"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :disabled="mode == 'view'"
                >
                  <template v-slot:option="option">{{
                    option.productDescription
                  }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <v-select
                  label="chargeDescription"
                  v-model="chargeCode"
                  :clearable="false"
                  :options="chargeCodeOptions || []"
                  :reduce="(obj) => obj.chargeCode"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :disabled="mode == 'view'"
                >
                  <template v-slot:option="option">{{
                    option.chargeDescription
                  }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <v-select
                  label="name"
                  v-model="chargeOwner"
                  :clearable="false"
                  :options="chargeOwners"
                  :reduce="(obj) => obj.value"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :disabled="mode == 'view'"
                >
                  <template v-slot:option="option">{{ option.name }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <v-select
                  label="code"
                  :clearable="false"
                  v-model="currencyId"
                  :options="allCurrencies"
                  :reduce="(obj) => obj.id"
                  :disabled="mode == 'view'"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <v-select
                  label="priceregion"
                  v-model="roundingType"
                  :clearable="false"
                  class="w-full"
                  :options="roundingTypes"
                  :disabled="mode == 'view'"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{
                    option.priceregion
                  }}</template>
                </v-select>
              </div>
            </div>
          </div>
          <div class="vx-col w-2/5 less-padding">
            <div class="vx-row border-left py-2" style="height: 100%">
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                <v-select
                  label="Contractdata"
                  v-model="duration"
                  :clearable="false"
                  :options="durationOptions || []"
                  :reduce="(obj) => obj.Contractdata"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :disabled="mode == 'view'"
                >
                  <template v-slot:option="option">{{
                    option.Contractdata
                  }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                <v-select
                  label="mCodeValue"
                  v-model="GLID"
                  :clearable="false"
                  :options="priceWithTemplate.glRealatedData"
                  :reduce="(obj) => obj.mCodeValue"
                  :disabled="mode == 'view'"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                <vs-input
                  class="w-full mb-2 font-semibold padding-zero"
                  v-model="planPrice"
                  :disabled="mode == 'view'"
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                <vs-input
                  class="w-full mb-2 font-semibold padding-zero"
                  v-model="sellingPrice"
                  :disabled="mode == 'view'"
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                <div class="whitespace-no-wrap p-3" style="cursor: pointer">
                  <feather-icon
                    icon="PlusIcon"
                    :title="$t('setup.label.AddPrice')"
                    class="icon_row"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                    @click.stop="addData()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="margin-bottom my-3" v-show="mode != 'view'"></div>

        <div class="vx-row less-padding">
          <div class="vx-col w-3/5 less-padding">
            <div class="vx-row border-left heading">
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.PlanCode") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.ProductCode") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.ChargeCode") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.ChargeOwner") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.Resource") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.RoundingType") }}
              </div>
            </div>
          </div>
          <div class="vx-col w-2/5 less-padding">
            <div class="vx-row border-left heading" style="height: 100%">
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                {{ $t("setup.label.Duration") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                {{ $t("setup.label.GLID") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                {{ $t("setup.label.ListPrice") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                {{ $t("setup.label.SellingPrice") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                {{ $t("setup.label.Actions") }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="vx-row less-padding"
          :key="index"
          :data="priceEl"
          v-for="(priceEl, index) in productPriceList"
        >
          <div class="vx-col w-3/5 less-padding">
            <div class="vx-row border-left py-2" style="height: 100%">
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <vs-input
                  class="w-full mb-2 font-semibold padding-zero"
                  :placeholder="$t('setup.label.EnterPlanDescription')"
                  v-model="priceEl.planCode"
                  readonly
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <v-select
                  label="productDescription"
                  v-model="priceEl.productId"
                  :clearable="false"
                  :options="priceWithTemplate.serviceData"
                  :reduce="(obj) => obj.id"
                  :disabled="mode == 'view'"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{
                    option.productDescription
                  }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <v-select
                  label="chargeDescription"
                  v-model="priceEl.chargeCode"
                  :options="chargeCodeOptions || []"
                  :clearable="false"
                  :reduce="(obj) => obj.chargeCode"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :disabled="prepaid || mode == 'view'"
                >
                  <template v-slot:option="option">{{
                    option.chargeDescription
                  }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <v-select
                  label="name"
                  v-model="priceEl.chargeOwner"
                  :clearable="false"
                  :options="chargeOwners"
                  :reduce="(obj) => obj.value"
                  :disabled="mode == 'view'"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{ option.name }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <v-select
                  label="code"
                  v-model="priceEl.currencyId"
                  :clearable="false"
                  :options="allCurrencies"
                  :reduce="(obj) => obj.id"
                  :disabled="mode == 'view'"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{ option.code }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <v-select
                  label="priceregion"
                  :clearable="false"
                  v-model="priceEl.roundingType"
                  :options="roundingTypes"
                  :disabled="mode == 'view'"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{
                    option.priceregion
                  }}</template>
                </v-select>
              </div>
            </div>
          </div>
          <div class="vx-col w-2/5 less-padding">
            <div class="vx-row border-left py-2" style="height: 100%">
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                <v-select
                  label="Contractdata"
                  v-model="priceEl.duration"
                  :options="durationOptions || []"
                  :reduce="(obj) => obj.id"
                  :clearable="false"
                  :disabled="mode == 'view'"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{
                    option.Contractdata
                  }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                <v-select
                  label="mCodeValue"
                  v-model="priceEl.glId"
                  :options="priceWithTemplate.glRealatedData"
                  :clearable="false"
                  :reduce="(obj) => obj.mCodeValue"
                  :disabled="mode == 'view'"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                <vs-input
                  class="w-full mb-2 font-semibold padding-zero"
                  v-model="priceEl.price"
                  :disabled="mode == 'view'"
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5 lg:w-1/5 xl:w-1/5">
                <vs-input
                  class="w-full mb-2 font-semibold padding-zero"
                  v-model="priceEl.sellingPrice"
                  :disabled="mode == 'view'"
                />
              </div>
              <div
                class="vx-col w-full flex sm:w-2/2 md:w-1/5 lg:w-1/5 xl:w-1/5"
              >
                <div class="whitespace-no-wrap p-3" style="cursor: pointer">
                  <feather-icon
                    class="icon_row text-success icon_row"
                    icon="CheckIcon"
                    svgClasses="w-5 h-5 text-success stroke-current cursor mr-4"
                    color="success"
                    :title="$t('setup.label.Save')"
                    :disabled="mode == 'view'"
                    v-show="mode != 'view'"
                    type="border"
                    @click.stop="editPrices"
                    size="small"
                  ></feather-icon>
                  <feather-icon
                    class="icon_row text-danger icon_row"
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    color="danger"
                    :title="$t('setup.label.Delete')"
                    v-show="mode != 'view'"
                    type="border"
                    @click.stop="deletePrice(priceEl.id)"
                    size="small"
                  ></feather-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="$t('setup.label.AddDiscount')"
            :active.sync="discountPopup"
            class="popup-close"
          >
            <form>
              <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                <div class="vx-col sm:w-full w-full">
                  <small class="font-semibold">{{
                    $t("setup.label.DiscountCode")
                  }}</small>
                  <v-select
                    label="discountCode"
                    v-model="selectedDiscount"
                    :options="productDiscounts"
                    :clearable="false"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(name) => name.discountId"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  />
                </div>
              </div>
              <div class="flex justify-center gap-6 mt-8 mb-4">
                <vs-button
                  icon-pack="feather"
                  type="border"
                  icon="icon-x"
                  @click="discountPopup = false"
                  >{{ $t("customers.label.cancel") }}</vs-button
                >
                <vs-button
                  icon-pack="feather"
                  @click="addUpdateDiscount"
                  icon="icon-search"
                  >{{ $t("setup.label.Submit") }}</vs-button
                >
              </div>
            </form>
          </vs-popup>
        </div>
        <div class="vx-row center my-5">
          <div class="vx-col w-full">
            <vs-button
              class="mr-3 footerButton-next"
              :disabled="productPriceList.length == 0"
              v-show="mode != 'view'"
              @click="$emit('completed')"
              >{{ $t("setup.label.SaveAndContinue") }}</vs-button
            >
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapState } from "vuex";

export default {
  props: {
    mode: String,
    planId: Number,
    routeId: Number,
    planName: String,
    planVersion: Number,
    planStatus: String,
  },
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      createPriceArray: [],
      editPriceArray: [],
      chargeOwners: [
        { name: "Self", value: "self" },
        { name: "Parent", value: "parent" },
      ],
      chargeCodeOptions: null,
      durationOptions: null,
      prepaid: false,
      currencyCode: "",
      roundingTypes: [
        "RoundingUp",
        "RoundingDown",
        "RoundingHalf",
        "RoundingNearest",
      ],
      id: "",
      idPrice: "",
      editToggle: false,
      pricingData: [{}],
      productCode: {},
      productTypeId: 0,
      chargeCode: "",
      chargeOwner: "",
      chargevariant: "",
      currencyId: "",
      discountId: "",
      isPrepaid: "",
      locale: "en",
      planCode: "",
      price: "",
      sellingPrice: "", // New field
      priceregion: "",
      productId: "",
      duration: "",
      roundingType: "",
      GLID: "",
      planPrice: "",
      isPriceUpdated: true,
      discountPopup: false,
      selectedDiscount: "",
      currentProductObj: {},
      currentProductIndex: "",
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      planWithTempate: (state) => state.planPrice.planWithTempate,
      priceWithTemplate: (state) => state.planPrice.priceWithTemplate,
      productDiscounts: (state) => state.planPrice.productDiscounts,
    }),
    backRoute() {
      if (Object.keys(this.$route.query).length) {
        return { name: "View Plan", params: { id: this.$route.params.id } };
      } else return { name: "Plan Pricing" };
    },
    allCurrencies() {
      const seen = new Set();
      return this.resourceOptions.filter((item) => {
        if (seen.has(item.id)) {
          return false;
        } else {
          seen.add(item.id);
          return true;
        }
      });
    },
    resourceOptions() {
      if (this.priceWithTemplate && this.priceWithTemplate.currencydata) {
        return [
          ...this.priceWithTemplate.currencydata.selectedCurrencyOptions,
          ...this.priceWithTemplate.currencydata.currencyOptions,
          ...this.priceWithTemplate.currencydata.noncurrencyOptions,
        ];
      } else return [];
    },
    productPriceList() {
      let arr = [];
      if (
        this.$route.query &&
        this.$route.query.type &&
        Object.keys(this.$route.query.type).length &&
        this.$route.query.type != "NONE"
      ) {
        this.editPriceArray.map((el) => {
          if (el.productCode == this.$route.query.type) {
            arr.push(el);
          }
        });
      } else {
        arr = [...this.editPriceArray];
      }
      return arr;
    },
  },
  methods: {
    async addData() {
      let Payload1 = {
        id: this.$route.params.id,
        planCode: this.priceWithTemplate.planCode,
        price: this.planPrice,
        sellingPrice: this.sellingPrice,
        chargeCode: this.chargeCode,
        duration: this.duration,
        isPrepaid: this.priceWithTemplate.isPrepaid === "N" ? false : true,
        currencyId: this.currencyId,
        productId: this.productCode.id,
        glId: this.GLID,
        productCode: this.productCode.productCode,
        discountId: this.selectedDiscount || 1,
        chargeOwner: this.chargeOwner,
        type: "c",
        chargevariant: this.priceWithTemplate.chargevariant[0].id,
        roundingType: this.roundingType,
        locale: "en",
      };

      try {
        await this.$store.dispatch("planPrice/addPriceAction", {
          id: this.id,
          data: Payload1,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Price added successfully!",
          type: "success",
        });
        this.getPriceWithTemplate();

        this.chargeCode = "";
        this.chargeOwner = "";
        this.chargevariant = "";
        this.currencyId = "";
        this.discountId = "";
        this.isPrepaid = "";
        this.locale = "en";
        this.planCode = "";
        this.price = "";
        this.planPrice = "";
        this.sellingPrice = "";
        this.priceregion = "";
        this.productId =
          this.$route.query &&
          this.$route.query.type &&
          Object.keys(this.$route.query.type).length
            ? this.productTypeId
            : "";
        this.duration = "";
        this.roundingType = "";
        this.GLID = "";
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async makerCheckerApproval() {
      try {
        this.$swal({
          title: "Do you want to send approval request?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await this.sendApproval();
              this.$router.push(`/setup/plan-pricing`);
            } catch (error) {
              this.$toasted.error("something went wrong!!", {
                duration: 2000,
              });
            }
          }
        });
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async sendApproval() {
      try {
        await this.$store.dispatch("planPrice/sendApprovalAction", this.id);
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Approval request sent!",
          type: "success",
        });
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async getPriceWithTemplate() {
      try {
        await this.$store.dispatch("planPrice/setPriceWithTemplate", this.id);
        this.priceWithTemplate.serviceData.push({
          productDescription: "NONE",
          id: 0,
        });
        this.editPriceArray = this.priceWithTemplate.pricingData.map((el) => {
          return { ...el };
        });
        this.editPriceArray.forEach((el) => {
          this.priceWithTemplate.priceRegionData.forEach((x) => {
            if (x.priceregion == el.priceregion) el.priceregion = x.id;
          });
        });

        this.editPriceArray.forEach((el) => {
          this.priceWithTemplate.chargeData.forEach((x) => {
            if (x.chargeDescription == el.chargeCode)
              el.chargeCode = x.chargeCode;
          });
        });

        this.editPriceArray.forEach((el) => {
          this.priceWithTemplate.chargevariant.forEach((x) => {
            if (x.value == el.chargeVariant) el.chargevariant = x.id;
            delete el.chargeVariant;
          });
        });
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async editPrices() {
      this.isPriceUpdated = true;
      for (let temp of this.editPriceArray) {
        delete temp.contractId;
        delete temp.billingFrequency;
        delete temp.currencyCode;
        temp.discountId = temp.discountId || 1;
        temp.locale = "en";
        try {
          await this.$store.dispatch("planPrice/updatePriceAction", {
            id: temp.id,
            data: temp,
          });
        } catch (e) {
          this.isPriceUpdated = false;
          this.$swal({
            title: "Error",
            icon: "error",
            text: e.message.errors[0].developerMessage,
            type: "error",
          });
          break;
        }
      }
      if (this.isPriceUpdated) {
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Price updated successfully!",
          type: "success",
        });
      }
    },
    async addUpdateDiscount() {
      let payload = {
        chargeOwner:
          this.productPriceList[this.currentProductIndex].chargeOwner,
        planCode: this.productPriceList[this.currentProductIndex].planCode,
        isPrepaid: this.productPriceList[this.currentProductIndex].isPrepaid,
        productId: this.productPriceList[this.currentProductIndex].productId,
        discountId: this.selectedDiscount || "1",
        chargeCode: this.productPriceList[this.currentProductIndex].chargeCode,
        currencyId: this.productPriceList[this.currentProductIndex].currencyId,
        price: this.productPriceList[this.currentProductIndex].price.toString(),
        chargevariant:
          this.productPriceList[this.currentProductIndex].chargevariant,
        locale: "en",
        type: "D",
      };
      try {
        await this.$store.dispatch("planPrice/updatePriceAction", {
          id: this.currentProductObj.id,
          data: payload,
        });
        this.discountPopup = false;
      } catch (error) {
        this.$toasted.error(error.message, {
          duration: 2000,
        });
      }
    },
    async deletePrice(id) {
      try {
        await this.$store.dispatch("planPrice/deletePriceAction", id);
        this.getPriceWithTemplate();
        this.$toasted.error("Successfully Deleted", {
          duration: 2000,
        });
      } catch (error) {
        this.$toasted.error(error.message, {
          duration: 2000,
        });
      }
    },
    async getProductDiscountTemplate() {
      try {
        await this.$store.dispatch("planPrice/fetchProductDiscountTemplate");
      } catch (error) {
        this.$toasted.error(error.message, {
          duration: 2000,
        });
      }
    },
    async getPlanData() {
      try {
        await this.$store.dispatch("planPrice/getPlanById", this.id);
      } catch (error) {
        //
      }
    },
  },
  async mounted() {
    this.id = this.planId;
    await this.getPlanData();
    this.getProductDiscountTemplate();
    await this.getPriceWithTemplate();
    const billFrequencyValues =
      this.planWithTempate.billfrequencyValues.map(Number);
    const commonBillData = this.priceWithTemplate.chargeData.filter((item) =>
      billFrequencyValues.includes(item.id)
    );
    const durationValues = this.planWithTempate.durationsValues.map(Number);
    const contractPeriods = this.priceWithTemplate.contractPeriods;
    const commonDurationData = contractPeriods.filter((item) =>
      durationValues.includes(item.id)
    );

    this.chargeCodeOptions = commonBillData;
    this.durationOptions = commonDurationData;
  },
};
</script>

<style scoped>
.padding-zero {
  padding-top: 0px;
}
::v-deep .vs__selected-options {
  overflow: hidden;
  width: 100px;
  font-size: 12px;
  display: block;
}
.price-table >>> .vs-input--input.normal {
  width: 80px;
  font-size: 12px;
}
::v-deep .vs--searchable .vs__dropdown-toggle {
  height: 40px;
}
::v-deep .vs-table-text {
  display: block;
}
::v-deep .vs__selected {
  text-wrap: nowrap;
}
.less-padding .vx-row > .vx-col {
  padding: 0 4px;
}
::v-deep .vs-table--not-data {
  display: none;
}
</style>
<style lang="scss" scoped>
.w-13 {
  width: 8.5%;
  padding: 0 4px;
  max-width: 90px;
  &:last-child {
    width: 4%;
  }
}
.border-left {
  border-bottom: 1px solid rgba(var(--vs-primary), 0.3);
  div {
    &:not(:first-child) {
      border-left: 1px solid rgba(var(--vs-primary), 0.3);
    }
    &:nth-child(6) {
      border-right: 1px solid rgba(var(--vs-primary), 0.3);
    }
  }
}
.heading {
  font-weight: 600;
  font-size: 0.9rem;
  div {
    padding: 0.5rem 5px !important;
  }
}
.margin-bottom {
  width: 100%;
  border-bottom: 1px solid #777;
  margin-bottom: 20px;
}
</style>
